export default "/images/hard-drive.svg?0d412a2d96d5f8e2a6f9526a63006f39";